import {DrawFrmThing} from "../../../drawfrm/DrawFrmThing";
import {inches, lineBlueHeavy} from "../../../const";
import {FrmShape} from "../../../drawfrm/FrmShape";
import {FrameProfileArgs} from "./ProfileArgs";
import {FrmRefPoint} from "../../../drawfrm/FrmRefPoint";

// Single Rabbet
export class FrameProfileSR extends DrawFrmThing {

    primaryDoorAnchor = new FrmRefPoint();
    // top of the outer face; the frame-profile view aligns a clamshell mullion on this.
    faceAnchor = new FrmRefPoint();

    constructor(args: FrameProfileArgs) {
        super();
        const {detail, jambDepth, jambFace, view, app, left, swingIn, clamshell, hideFaces, hideFaceDims, flipY} = args;

        const shape = new FrmShape(`frameProfile:SR:${left ? "left" : "right"}`, {
            dimensionMode: view.dimensionMode,
            thing: this,
            app: app,
        });
        shape.strokeColor = lineBlueHeavy;
        shape.horizontalDimensionSide = left ? "left" : "right";
        if (!left) shape.invertX();
        if(swingIn !== !!flipY) shape.invertY();

        //  __
        // |  |---------------|   top return hook + top face
        // |__|               |
        //                    |
        //                    |   throat (flexes with jamb depth)
        //                    |
        //              |-----|   single rabbet (steps in once)
        //  __          |
        // |  |---------|         bottom face + bottom return hook
        // |__|

        const hookLip = 0.4 * inches;  // horizontal lip of the return
        const hookDrop = 0.4 * inches; // depth of the return pocket
        const face = 2 * inches;       // top face width
        const upperThroat = 70;        // throat above the rabbet (flexes with jamb depth)
        const rabbet = 0.5 * inches;   // how far the single rabbet steps in
        const lowerThroat = 25;        // throat below the rabbet (stop height)

        // top return hook (lip tip -> left -> up), opening to the right
        shape.start(0, 0);
        const topLip = shape.lineTo(-hookLip, 0);
        const topHook = shape.lineTo(0, -hookDrop);
        if(clamshell) { topLip.setPenUp(); topHook.setPenUp(); }
        else { topLip.linkDimension(detail.drywallLip, "extended"); topHook.linkDimension(detail.drywallHookDrop, "extended"); }

        // top face
        const topFace = shape.lineTo(face, 0);

        // upper throat (flexes with jamb depth)
        shape.lineTo(0, upperThroat);

        // single rabbet (one step in toward the stop)
        shape.lineTo(-rabbet, 0);

        // lower throat
        const throat = shape.lineTo(0, lowerThroat).linkDimension(detail.rabbetDepth);

        this.primaryDoorAnchor.setLocalPoint(throat.pointA);

        // bottom face (shorter than the top by the rabbet)
        const bottomFace = shape.lineTo(-(face - rabbet), 0);

        // bottom return hook (down -> right lip), mirrors the top
        const bottomHook = shape.lineTo(0, -hookDrop);
        bottomHook.dimMatches(topHook);
        const bottomLip = shape.lineTo(hookLip, 0);
        bottomLip.dimMatches(topLip);
        if(clamshell) { bottomHook.setPenUp(); bottomLip.setPenUp(); }

        // jamb depth drives the overall throat (face-to-face)
        shape.addDimension(topFace.getStartpoint(), bottomFace.getEndpoint(), jambDepth);

        // clamshell secondary side: omit the top/bottom faces so the primary side's
        // faces cap the merged mullion (avoids a doubled/gapped cap).
        if(hideFaces) { topFace.setPenUp(); bottomFace.setPenUp(); }
        if(hideFaces || hideFaceDims) shape.hideDimensionsForVars([jambFace, jambDepth]);
        this.faceAnchor.setLocalPoint(topFace.getStartpoint());
        shape.done();
    }
}
